// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.greenDay:not(.-selectedStart):not(.-selectedBetween):not(.-selectedEnd):not(.-selected) {
    background-color: green!important;
    color: white!important;
}

.greenDay .-selected .custom_select_day{
    background-color: green!important;
    color: white!important;
}

.custom_select_day:not(.greenDay) {
    background-color:blue!important;
    color: white!important;
}

  
.blueDay:not(.-selectedStart):not(.-selectedBetween):not(.-selectedEnd):not(.-selected) {
    background-color:blue!important;
    color: white!important;
     
}
  
.redDay:not(.-selectedStart):not(.-selectedBetween):not(.-selectedEnd):not(.-selected) {
    background-color: red!important;
    color: white!important;
    
}

.custom_calendar {
    box-shadow: 0 1em 3em rgba(156, 136, 255, 0.2);
}
   
.custom_today_day {
    background-color: #e67e22 !important;
} 
  
.custom_today_day::after {
    visibility: hidden;
}
  
  `, "",{"version":3,"sources":["webpack://./Scripts/app/components/finalizar-orcamento/calendar.css"],"names":[],"mappings":"AAAA;IACI,iCAAiC;IACjC,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;IACjC,sBAAsB;AAC1B;;AAEA;IACI,+BAA+B;IAC/B,sBAAsB;AAC1B;;;AAGA;IACI,+BAA+B;IAC/B,sBAAsB;;AAE1B;;AAEA;IACI,+BAA+B;IAC/B,sBAAsB;;AAE1B;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,kBAAkB;AACtB","sourcesContent":[".greenDay:not(.-selectedStart):not(.-selectedBetween):not(.-selectedEnd):not(.-selected) {\r\n    background-color: green!important;\r\n    color: white!important;\r\n}\r\n\r\n.greenDay .-selected .custom_select_day{\r\n    background-color: green!important;\r\n    color: white!important;\r\n}\r\n\r\n.custom_select_day:not(.greenDay) {\r\n    background-color:blue!important;\r\n    color: white!important;\r\n}\r\n\r\n  \r\n.blueDay:not(.-selectedStart):not(.-selectedBetween):not(.-selectedEnd):not(.-selected) {\r\n    background-color:blue!important;\r\n    color: white!important;\r\n     \r\n}\r\n  \r\n.redDay:not(.-selectedStart):not(.-selectedBetween):not(.-selectedEnd):not(.-selected) {\r\n    background-color: red!important;\r\n    color: white!important;\r\n    \r\n}\r\n\r\n.custom_calendar {\r\n    box-shadow: 0 1em 3em rgba(156, 136, 255, 0.2);\r\n}\r\n   \r\n.custom_today_day {\r\n    background-color: #e67e22 !important;\r\n} \r\n  \r\n.custom_today_day::after {\r\n    visibility: hidden;\r\n}\r\n  \r\n  "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
